
import { Component, ChangeDetectionStrategy } from '@angular/core';
import type { ZoomResultsColumnCellRendererParams } from '@nts/std/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import moment from 'moment';


// create your cellEditor as a Angular component
@Component({
    template: `
        @if (this.params?.data) {
          <div>
            {{ value }}
          </div>
        } @else {
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        }
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ZoomResultsDateTimeOffsetCellRendererComponent implements AgRendererComponent {
    params: ZoomResultsColumnCellRendererParams;
    private _value = null;

    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ZoomResultsColumnCellRendererParams): void {
        this.params = params;
    }

    get value() {
        if (this._value == null) {
            const currentValue = this.params.data[Number.parseInt(this.params.colDef.field, 10)];
            if (currentValue != null) {
                const parsedZone = moment(currentValue).parseZone();
                this._value = parsedZone.local().format('L LT');
            } else {
                this._value = '';
            }
        }
        return this._value;
    }
}
